import { Paper, Skeleton } from '@mui/material';

const FormSkeleton = ({ nb }) => {
    return (
        <div>
            <Paper sx={{ px: 2, pt: 1, pb: 2, mt: 2 }}>

                {[...Array(nb)].map((_, i) => (
                    <Skeleton key={i} variant="text" height={68} />
                ))}

            </Paper>
            <Skeleton variant="rounded" height={40} width={160} sx={{ mt: 2 }} />
        </div>
    );
};

export default FormSkeleton;